import { render, staticRenderFns } from "./TextColorsRenderer.vue?vue&type=template&id=b5856e22"
import script from "./TextColorsRenderer.vue?vue&type=script&lang=js"
export * from "./TextColorsRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports